// extracted by mini-css-extract-plugin
export default {"blockSelect":"ButtonRowSelect_blockSelect__nqM0p","titleRow":"ButtonRowSelect_titleRow__OyFXl","select":"ButtonRowSelect_select__s06Oc"};